var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLevels = function SvgLevels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1394 17.9172C14.3624 20.6943 9.85986 20.6943 7.0828 17.9172C5.69427 16.5287 5 14.7088 5 12.8889C5 11.069 5.69426 9.2491 7.0828 7.86057C7.0828 7.86057 7.66671 9.3333 9.44449 10.2222C9.44449 8.44441 9.88893 5.77774 12.0986 4C13.8889 5.77778 15.7477 6.46884 17.1394 7.86057C18.528 9.2491 19.2222 11.069 19.2222 12.8889C19.2222 14.7088 18.528 16.5287 17.1394 17.9172Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLevels;